import * as React from 'react';
import ReactDOM from 'react-dom';
import styled, { StyledComponentClass } from 'styled-components';
import toPairs from 'lodash.topairs';

export interface Props {
  className?: string;
  domElement?: HTMLElement; // container for the portal element(s)
  shadowElement?: HTMLElement; // container portal element(s) should position relative to
}
export interface Context {
  portalContainer?: HTMLElement;
}

class PortalWrapper extends React.Component<Props, {}> {
  public context: Context;

  public render() {
    const { children, className, domElement } = this.props;
    const { portalContainer } = this.context;
    return ReactDOM.createPortal(
      <div className={className}>{children}</div>,
      domElement || portalContainer || document.getElementById('root'),
    );
  }
}

const computePosition = (shadowEl: HTMLElement) => {
  const { height = 0, left = 0, top = 0, width = 0 } =
    (shadowEl && shadowEl.getBoundingClientRect()) || {};

  // IE11 does not support pageX, pageY :(
  const { pageXOffset, pageYOffset } = window;

  return {
    left: left + pageXOffset,
    height,
    top: top + pageYOffset,
    width,
  };
};

// tslint:disable no-nested-template-literals
export default styled(PortalWrapper)`
  pointer-events: none;
  position: absolute;
  z-index: 1;

  > * {
    pointer-events: auto;
  }

  ${props =>
    toPairs(computePosition(props.shadowElement)).reduce(
      (style, [p, v]) => (style += `${p}: ${v}px;\n`),
      '',
    )};
`;
